
import type { WatchStopHandle } from '@vue/composition-api';
import { ref, watch } from '@vue/composition-api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Note } from '05-ui-kit';
import type { StatusType } from '~/type/StatusType';
import TextareaButton from '~/components/review-component/TextareaButton/TextareaButton.vue';
import { useUserStore } from '~/store/user';
interface AnswerData {
  id: number;
  name: string;
  email?: string;
  entity: string;
  text: string;
}
interface Props {
  productId: number;
  parentId?: string;
  /**
  * Имя пользователя на чей вопрос/комментарий мы отвечаем
  */
  userName?: string;
  padding: string;
  border: string;
  height: number;
  status?: StatusType;
  error?: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  productId: {
    key: "productId",
    required: true,
    type: Number
  },
  parentId: {
    key: "parentId",
    required: false,
    type: String
  },
  userName: {
    key: "userName",
    required: false,
    type: String
  },
  padding: {
    key: "padding",
    required: false,
    type: String,
    default: '0'
  },
  border: {
    key: "border",
    required: false,
    type: String,
    default: 'none'
  },
  height: {
    key: "height",
    required: false,
    type: Number,
    default: 45
  },
  status: {
    key: "status",
    required: false,
    type: null
  },
  error: {
    key: "error",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const observer = ref();
  const {
    user: userData
  } = useUserStore();
  const fields = ref({
    id: props.productId,
    name: userData?.name || `Гость ${Math.ceil(Math.random() * 101)}`,
    email: userData?.email,
    entity: '',
    text: ''
  });
  const submited = ref(false);
  const resetWatcher = ref<WatchStopHandle | null>(null);
  if (props.parentId) {
    fields.value.entity = props.parentId;
    fields.value.text = `${props.userName}, `;
  }
  function onClick() {
    observer.value.validateWithInfo().then(({
      isValid
    }: {
      isValid: boolean;
    }) => {
      if (isValid) onSubmit();
    });
  }
  function onSubmit() {
    /**
    * Срабатывает при отправки запроса
    */
    emit('send', fields.value);
  }
  watch(() => props.status, val => {
    if (val === 'success') {
      submited.value = true;
      resetWatcher.value = watch(() => fields.value, () => {
        submited.value = false;
        resetWatcher.value?.();
      }, {
        deep: true
      });
    }
  });
  return {
    observer,
    fields,
    submited,
    onClick
  };
};
__sfc_main.components = Object.assign({
  Note,
  ValidationObserver,
  ValidationProvider,
  TextareaButton
}, __sfc_main.components);
export default __sfc_main;
